import type { ConversationItem } from '@vivport/backend/types';
import { Badge } from '@/components/ui/badge';
import { Bot, ExternalLink, Layers, Sparkles, Tag } from 'lucide-react';
import { AppLink } from '@/components/ui/app-link';

type Work4MeEntityCreatedItem = Extract<ConversationItem, { kind: 'event_work4me_entity_created' }>;

export interface ProvenanceWork4MeEntityCardProps {
  item: Work4MeEntityCreatedItem;
}

export function ProvenanceWork4MeEntityCard({ item }: ProvenanceWork4MeEntityCardProps) {
  const icon = item.entityType === 'TAG'
    ? <Tag className="h-4 w-4 shrink-0" />
    : item.entityType === 'TAG_GROUP'
      ? <Layers className="h-4 w-4 shrink-0" />
      : item.entityType === 'AGENT'
        ? <Bot className="h-4 w-4 shrink-0" />
        : <Sparkles className="h-4 w-4 shrink-0" />;

  return (
    <AppLink
      to={item.url}
      className="block w-full rounded-lg border border-border p-3 text-sm text-foreground hover:bg-muted/40 transition-colors"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            {icon}
            <p className="font-medium truncate">{item.title}</p>
          </div>
          {item.description ? <p className="text-xs mt-1 text-muted-foreground line-clamp-2">{item.description}</p> : null}
        </div>
        <div className="flex flex-col items-end gap-2 shrink-0">
          <Badge variant="outline">{item.entityType}</Badge>
          <span className="text-xs text-primary inline-flex items-center gap-1">
            Open in Work4Me
            <ExternalLink className="h-3.5 w-3.5" />
          </span>
        </div>
      </div>
    </AppLink>
  );
}
